import { DialogEnum } from "../dialogs/Dialog";
import DialogButton from "../dialogs/DialogButton";

interface HelpButtonProps {
  dialog: DialogEnum | null;
  setDialog: Function;
}

export const HelpButton = ({ dialog, setDialog }: HelpButtonProps) => (
  <DialogButton
    currentDialog={dialog}
    wantedDialog={DialogEnum.Hotkeys}
    setDialog={setDialog}
    hotkey="h"
    className="RoundButton"
    title="Help"
  >
    <strong>?</strong>
  </DialogButton>
);
